import { takeEvery, put } from 'redux-saga/effects';

import {
    CREATE_CALENDAR_QUESTION,
    DELETE_CALENDAR_QUESTION,
    GET_CALENDAR_QUIZZES_LIST,
    CALENDAR_QUESTION_COPY,
    UPLOAD_CALENDAR_QUESTION_COVER,
    UPDATE_CALENDAR_QUESTION,
    GET_HATCH_QUESTIONS,
    CALENDAR_QUESTION_PIN,
    UPDATE_CALENDAR_QUESTION_COVER,
    UPDATE_CALENDAR_QUESTION_DRAG_DROP
} from './constants';

import {
    requestCalendarQuestionCreation,
    requestDeleteCalendarQuestion,
    requestCalendarQuizzesList,
    requestCalendarQuestionCopy,
    requestQuestionCoverUpload,
    requestCalendarQuestionUpdate,
    requestGetHatchQuestions,
    requestHatchQuestionPin,
    requestupdateCalendarQuestionCover,
    requestQuestionDrop
} from './api';

import {
    createCalendarQuestionSuccess,
    deleteCalendarQuestionSuccess,
    getCalendarQuizzesListSuccess,
    calendarQuestionCopySuccess,
    uploadCalendarQuestionCoverSuccess,
    updateCalendarQuestionSuccess,
    getHatchQuestionsSuccess,
    hatchQuestionPinSuccess,
    updateCalendarQuestionCoverSuccess,
    updateQuestionDragDropSuccess
} from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{questions, type}>>}
 */
function* getHatchQuestions( actionObj ) {
    const hatchQuestions = yield requestGetHatchQuestions( actionObj.hatchID )
    if ( hatchQuestions ) {
        yield put( getHatchQuestionsSuccess( hatchQuestions ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* createCalendarQuestion( actionObj ) {
    const newQuestion = yield requestCalendarQuestionCreation( actionObj.hatchID, actionObj.questionType, actionObj.questionText, actionObj.langID );

    if ( newQuestion ) {
        yield put( createCalendarQuestionSuccess( newQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* deleteCalendarQuestion( actionObj ) {
    const updatedQuestion = yield requestDeleteCalendarQuestion( actionObj.questionID )

    if ( updatedQuestion ) {
        yield put( deleteCalendarQuestionSuccess( updatedQuestion ) );
    }
}

/**
 *
 * @returns {IterableIterator<PutEffect<{type, quizzesList}>>}
 */
function* getCalendarQuizzesList() {
    const quizzesList = yield requestCalendarQuizzesList();

    if ( quizzesList ) {
        yield put( getCalendarQuizzesListSuccess( quizzesList ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* calendarQuestionCopy( actionObj ) {
    const addQuestion = yield requestCalendarQuestionCopy( actionObj.questionID, actionObj.hatchID );

    if ( addQuestion ) {
        yield put( calendarQuestionCopySuccess( addQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* uploadQuestionCover( actionObj ) {
    const updatedQuestion = yield requestQuestionCoverUpload( actionObj.questionID, actionObj.localizationID, actionObj.image, actionObj.screenType );
    if ( updatedQuestion ) {
        yield put( uploadCalendarQuestionCoverSuccess( updatedQuestion ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{updatedQuestionPiece, type}>>}
 */
function* updateCalendarQuestion( actionObj ) {
    const requestObj = {
        [ actionObj.keyName ]: actionObj.updateQuestionPiece
    };
    const updateData = yield requestCalendarQuestionUpdate( actionObj.questionID, requestObj );
    if ( updateData ) {
        yield put( updateCalendarQuestionSuccess( updateData ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* hatchQuestionPin( actionObj ) {
    const questionPin = yield requestHatchQuestionPin( actionObj.localizationID );

    if ( questionPin ) {
        yield put( hatchQuestionPinSuccess( questionPin ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{question, type}>>}
 */
function* updateCalendarQuestionCover( actionObj ) {
    const question = yield requestupdateCalendarQuestionCover( actionObj.id, actionObj.localizationId );
    if ( question ) {
        yield put( updateCalendarQuestionCoverSuccess( question ) );
    }
}


/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{newQuestions, type}>>}
 */
function* dragDropQuestion( actionObj ) {
    const newQuestions = yield requestQuestionDrop( actionObj.id, actionObj.result );
    if ( newQuestions ) {
        yield put( updateQuestionDragDropSuccess( newQuestions ) );
    }
}

function* watchQuestions() {
    yield takeEvery( UPDATE_CALENDAR_QUESTION_DRAG_DROP, dragDropQuestion );
    yield takeEvery( CREATE_CALENDAR_QUESTION, createCalendarQuestion );
    yield takeEvery( UPLOAD_CALENDAR_QUESTION_COVER, uploadQuestionCover );
    yield takeEvery( UPDATE_CALENDAR_QUESTION, updateCalendarQuestion );
    yield takeEvery( DELETE_CALENDAR_QUESTION, deleteCalendarQuestion );
    yield takeEvery( GET_CALENDAR_QUIZZES_LIST, getCalendarQuizzesList );
    yield takeEvery( CALENDAR_QUESTION_COPY, calendarQuestionCopy );
    yield takeEvery( GET_HATCH_QUESTIONS, getHatchQuestions );
    yield takeEvery( CALENDAR_QUESTION_PIN, hatchQuestionPin );
    yield takeEvery( UPDATE_CALENDAR_QUESTION_COVER, updateCalendarQuestionCover );
}

export default watchQuestions;